import { Component, Inject, OnInit, DOCUMENT, ChangeDetectionStrategy } from '@angular/core';


@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrls: ['./not-found.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotFoundComponent implements OnInit {
  constructor(public document: Document) {}

  ngOnInit(): void {}
  getCurrentLocation() {
    return this.document.location.href;
  }
}
